export const SHOP_COUNTRIES_REQUEST = 'SHOP_COUNTRIES_REQUEST';
export const SHOP_COUNTRIES_SUCCESS = 'SHOP_COUNTRIES_SUCCESS';
export const SHOP_COUNTRIES_ERROR = 'SHOP_COUNTRIES_ERROR';
